<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M7.5 6.5v11" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
    <path d="M16.5 6.5v11" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
  </svg>
</template>

